import { connect } from 'react-redux';

import DraftStatusActions from './component';

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(DraftStatusActions);
